import React from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Bono 1 – Mapa Terapéutico',
  image: 'https://cdn.magicpatterns.com/uploads/6S2kQxMuZBxyDxjaDDuadq/BONO_1_PSICOLOGIA.png',
  desc: 'Un mapa visual que resume todo el recorrido terapéutico.',
  features: ['Visualizar el proceso completo', 'Organizar fases, técnicas y sesiones', 'Trabajar con mayor orden y seguridad'],
  footer: 'Ideal para tener siempre a mano en la consulta.'
}, {
  title: 'Bono 2 – Checklist Inicial para Pacientes',
  image: 'https://cdn.magicpatterns.com/uploads/smj3fdrBY8EhgB4f9hqf6G/bono_2_PSICOLOGIA.png',
  desc: 'Los pasos clave que el paciente debe seguir desde el primer día.',
  features: ['Ordenar el inicio del tratamiento', 'Evitar confusiones', 'Generar adherencia', 'Aportar claridad desde la primera sesión'],
  footer: 'Perfecto para entregar al comenzar el proceso terapéutico.'
}, {
  title: 'Bono 3 – Kit de Mensajes Terapéuticos',
  image: 'https://cdn.magicpatterns.com/uploads/uV3ZNXDtV2AzeGzG6cD1cD/BONO_3_PSICOLOGIA.png',
  desc: '21 mensajes listos para enviar por WhatsApp.',
  features: ['Anti-ansiedad', 'Motivacionales', 'Recordatorios', 'Seguimiento entre sesiones'],
  footer: 'Reduce el abandono, mejora la adherencia y fortalece el vínculo terapéutico sin perder tiempo.'
}];
export function BonusSection() {
  return <section className="py-16 px-4 bg-gradient-to-b from-purple-50 to-white" data-id="element-41">
      <div className="max-w-4xl mx-auto" data-id="element-42">
        <div className="text-center mb-12" data-id="element-43">
          <span className="inline-flex items-center gap-2 px-4 py-1 bg-red-100 text-red-600 font-bold rounded-full text-sm uppercase mb-4" data-id="element-44">
            <Gift className="w-4 h-4" data-id="element-45" />
            Solo por hoy
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900" data-id="element-46">
            BONOS EXCLUSIVOS (GRATIS HOY)
          </h2>
          <p className="text-gray-600 mt-4" data-id="element-47">
            Llévate estos 3 recursos adicionales totalmente gratis al adquirir
            el Mega Pack hoy.
          </p>
        </div>

        <div className="space-y-12" data-id="element-48">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white rounded-2xl shadow-lg border border-purple-100 overflow-hidden flex flex-col md:flex-row" data-id="element-49">
              <div className="md:w-2/5 bg-purple-50 p-6 flex items-center justify-center" data-id="element-50">
                <img src={bonus.image} alt={bonus.title} className="w-full max-w-[200px] drop-shadow-xl transform hover:scale-105 transition-transform duration-300" data-id="element-51" />
              </div>
              <div className="md:w-3/5 p-6 md:p-8" data-id="element-52">
                <div className="inline-block px-3 py-1 bg-purple-100 text-purple-700 text-xs font-bold rounded mb-3" data-id="element-53">
                  GRATIS (Valor $15 USD)
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-54">
                  🎁 {bonus.title}
                </h3>
                <p className="text-gray-600 mb-4 font-medium" data-id="element-55">{bonus.desc}</p>

                <ul className="space-y-2 mb-6" data-id="element-56">
                  {bonus.features.map((feature, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-57">
                      <div className="w-1.5 h-1.5 rounded-full bg-purple-400 mt-1.5" data-id="element-58" />
                      {feature}
                    </li>)}
                </ul>

                <p className="text-sm text-purple-600 font-medium italic border-t border-purple-50 pt-3" data-id="element-59">
                  {bonus.footer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}